import React from 'react'
import {  Card, Accordion, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/BoxItem.css'; // Tell webpack that Button.js uses these styles
import BoxCard from '../containers/comps/BoxCardContainer'
import '../css/BoxItemDropDown.css'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig'


class BoxItemDropDownDownGroup extends React.Component {
    constructor(props) {
        super(props);
        this.swalConfirm = this.swalConfirm.bind(this)
    }

    swalConfirm(VRN, mappingID, groupName, groupID) {

        Swal.fire({
            html: "Are you sure you want to remove vehicle <b>" + VRN + " </b>from group <b>" + groupName + " </b>?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
        }).then((result) => {
            if (result.isConfirmed) {
                
                axiosConfig.post("Portal/RemoveGroupVehicle",
                    {
                        
                            GroupID: groupID,
                            MappingID: mappingID,
                            GroupName : groupName,
                            VRN: VRN,
                            UserBranchID: localStorage.getItem('selectedBranch')
                        
                    }
                )
                    .then(Response => {
                    
                        let responseCode = Response.data.status.responseCode

                            if(responseCode === '00')
                            {
                                Swal.fire(
                                    {
                                        text: Response.data.status.description,
                                        icon: 'success'
                                    }
                                )
                                debugger
                                localStorage.setItem('tabClosed', 'false');
                                window.location.reload();
                            }
                            else
                            {
                                Swal.fire(
                                    {
                                        text: Response.data.status.description,
                                        icon: 'error'
                                    }
                                )
                            }

                        console.log(Response.data)
                    })
                    .catch(error => {
                        console.log("Error !! Not deleted PAN")

                        Swal.fire(
                            'Error',
                            'Error! Please try again',
                            'error'
                        )
                    })

            }
        })
    }


    render() {
        return (
            <Card className="panel panel-default mb-0">


                <Accordion.Toggle as={Card.Header} eventKey={this.props.index + 1} className="p-0">
                    <span>

                        <Row>
                            <div>
                            <strong> {this.props.index + 1}:  </strong>
                            </div>
                            <div>&nbsp;</div>
                            <div>
                                <strong>{this.props.name}</strong>
                            </div>
                            <div className="heading-elements">
                                <ul id={"ul" + this.props.name} className="list-inline mb-0">
                                    <li id={"li" + this.props.name}><div><FeatherIcon className="iconspacing" icon="chevron-down" size="20" /></div></li>
                                </ul>
                            </div>


                        </Row>
                    </span>
                    <div className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href={"#" + this.props.index + 1}>
                    </div>
                </Accordion.Toggle>

                <Accordion.Collapse id={this.props.index + 1} eventKey={this.props.index + 1} className="panel-collapse collapse in">
                    <Card.Body>

                        {this.props.accordionSubItems.map((el, index) => {
                            return (
                                
                                <div>
                                    {this.props.groupID == '0' ?

                                    <div id={index} className="box-item btn btn-default w-100 tt">{el.vrn}</div>

                                    :                                  

                                    <div id={index} className="box-item btn btn-default w-100 tt">{el.vrn}
                                    <a data-action="close" style={{ float: 'right' }} 
                                     onClick={() => this.swalConfirm(el.vrn, el.mappingID, this.props.name, this.props.groupID)}><FeatherIcon className="iconspacing" icon="x-circle" size="15" /></a>
                                    </div> 


                                    }

                                </div>
                            )
                        })}
                    </Card.Body>
                </Accordion.Collapse>

            </Card >
        );
    }
}

export default BoxItemDropDownDownGroup;